var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('iframe',{staticStyle:{"width":"100%","height":"100vh","border":"none"},attrs:{"src":_vm.iframe}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }